import { authRoles } from 'app/auth';
import ParositasAdatlapTable from 'app/admin/parositasadatlap/table/ParositasAdatlapTable';
import ParositasAdatlapEditForm from 'app/admin/parositasadatlap/editform/ParositasAdatlapEditForm';

export default [
	{
		path: '/parositasadatlap/edit/:id',
		component: ParositasAdatlapEditForm,
		auth: authRoles.szervezo
	},
	{
		path: '/parositasadatlap/:sessionNameParam?',
		component: ParositasAdatlapTable,
		auth: authRoles.szervezo
	}
];
